import config from 'config';
import utils from 'utils';

const baseUrl = config.api[window.location.hostname].baseUrl;

const getAllPendings = () => {
  return fetch(`${baseUrl}/mod/tips/get-pendings`, {
    method: 'GET',
    headers: {
      Authorization: window.user.token,
      ...utils.getHeaders(),
    },
  }).then(utils.fetch.process);
};

const edit = data => {
  return fetch(`${baseUrl}/mod/tips/edit`, {
    method: 'POST',
    headers: {
      Authorization: window.user.token,
      ...utils.getHeaders(),
    },
    body: JSON.stringify(data),
  }).then(utils.fetch.process);
};

const apiTips = {
  getAllPendings,
  edit,
};

export default apiTips;
